import { render } from "./FooterMobile.vue?vue&type=template&id=438d62fb&scoped=true"
import script from "./FooterMobile.vue?vue&type=script&lang=js"
export * from "./FooterMobile.vue?vue&type=script&lang=js"

import "./FooterMobile.vue?vue&type=style&index=0&id=438d62fb&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-438d62fb"]])

export default __exports__